/*
 * Punto di ingresso del modulo logger.
 *
 * Riesporta i simboli pubblici dai tre sotto-moduli:
 *   - LogLevel.ts          → enum e logica di confronto livelli
 *   - ConsoleInterceptor.ts → filtraggio globale console.*
 *   - AppLogger.ts          → logger personalizzato con prefisso e livello per istanza
 *
 * Gli alias setConsoleMinLogLevel / getConsoleMinLogLevel mantengono
 * la retrocompatibilità con il codice che importava dalla vecchia struttura.
 */

// Logger e interfaccia
export { type ILogger, logger } from "./AppLogger";

// Livelli di log e funzioni di confronto
export { LogLevel, isLevelEnabled } from "./LogLevel";

// Controllo globale della console (intercettazione)
export {
    setGlobalMinLevel as setConsoleMinLogLevel,
    getGlobalMinLevel as getConsoleMinLogLevel,
    shouldLog,
} from "./ConsoleInterceptor";
